export enum Instruments {
    Accordion = 'accordion',
    AcousticGuitar = 'acoustic_guitar',
    Autoharp = 'autoharp',
    BackingTrack = 'backing_track',
    Banjo = 'banjo',
    BassGuitar = 'bass_guitar',
    Bassoon = 'bassoon',
    Beatbox = 'beatbox',
    Beats = 'beats',
    Bell = 'bell',
    Bongo = 'bongo',
    Cabasa = 'cabasa',
    Celeste = 'celeste',
    Cello = 'cello',
    Chant = 'chant',
    Child = 'child',
    Chime = 'chime',
    Choir = 'choir',
    Clap = 'clap',
    Clarinet = 'clarinet',
    ClassicalGuitar = 'classical_guitar',
    Claves = 'claves',
    ClosedHiHat = 'closed_hihat',
    Conga = 'conga',
    Contrabassoon = 'contrabassoon',
    Cowbell = 'cowbell',
    Crash = 'crash',
    Crotales = 'crotales',
    Cymbals = 'cymbals',
    Digirido = 'digirido',
    Djembe = 'djembe',
    DoubleBass = 'double_bass',
    Downer = 'downer',
    Drumkit = 'drumkit',
    Duduk = 'duduk',
    EightHundredEight = '808',
    ElectricGuitar = 'electric_guitar',
    ElectricPiano = 'electric_piano',
    EnglishHorn = 'english_horn',
    Erhu = 'erhu',
    Female = 'female',
    Flute = 'flute',
    Foley = 'foley',
    FrenchHorn = 'french_horn',
    FullDrum = 'full_drum',
    Glockenspiel = 'glockenspiel',
    Gong = 'gong',
    Harmonica = 'harmonica',
    Harp = 'harp',
    Harpsichord = 'harpsichord',
    HiHat = 'hi_hat',
    Hit = 'hit',
    Horn = 'horn',
    Impact = 'impact',
    Kalimba = 'kalimba',
    Kick = 'kick',
    Koto = 'koto',
    Layer = 'layer',
    LogDrum = 'log_drum',
    Male = 'male',
    Mandolin = 'mandolin',
    Marimba = 'marimba',
    Noise = 'noise',
    Oboe = 'oboe',
    OpenHiHat = 'open_hi_hat',
    Orchestra = 'orchestra',
    Orchestral = 'orchestral',
    Organ = 'organ',
    Oud = 'oud',
    Piano = 'piano',
    Quartet = 'quartet',
    Reverse = 'reverse',
    Rhodes = 'rhodes',
    Rap = 'rap',
    Ride = 'ride',
    Rimshot = 'rimshot',
    Riser = 'riser',
    Saxophone = 'saxophone',
    Scream = 'scream',
    Shaker = 'shaker',
    Shout = 'shout',
    Singing = 'singing',
    Sitar = 'sitar',
    Snap = 'snap',
    Snare = 'snare',
    SoundDesign = 'sound_design',
    SoundEffect = 'sound_effect',
    Soundscape = 'soundscape',
    Splash = 'splash',
    Spoken = 'spoken',
    SteelDrum = 'steel_drum',
    SteelGuitar = 'steel_guitar',
    SteelSlideGuitar = 'steel_slide_guitar',
    Sub = 'sub',
    Sweep = 'sweep',
    SynthBass = 'synth_bass',
    SynthLead = 'synth_lead',
    SynthPad = 'synth_pad',
    SynthPlucked = 'synth_plucked',
    SynthPolyphonic = 'synth_polyphonic',
    SynthStab = 'synth_stab',
    SynthTexture = 'synth_texture',
    Tabla = 'tabla',
    Tambourine = 'tambourine',
    Timbale = 'timbale',
    Tom = 'tom',
    Topline = 'topline',
    Triangle = 'triangle',
    Trombone = 'trombone',
    Trumpet = 'trumpet',
    Tuba = 'tuba',
    TubularBells = 'tubular_bells',
    TwelveString = '12_string',
    Ukulele = 'ukulele',
    UprightBass = 'upright_bass',
    Vibraphone = 'vibraphone',
    Viola = 'viola',
    Violin = 'violin',
    Vocoder = 'vocoder',
    Woodblock = 'woodblock',
    Wooden = 'wooden',
    Xylophone = 'xylophone',
}
